import React, { useState, useEffect, useCallback } from 'react';
import { Container, Table } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import t, { partial } from '../../../util/translation/translation';
import Api from '../../../util/api';

const EventAttendenceCard = ({ companyID, setLoading }) => {
  const s = partial('shared');
  const p = partial('CompanyFormPage');
  const [eventAttendence, setEventAttendence] = useState([]);

  const fetchEventAttendence = useCallback(async () => {
    setLoading(true);
    try {
      const attendence = await Api.events.getCompanyAttendence(companyID);
      setLoading(false);
      setEventAttendence(attendence);
    } catch (error) {
      setLoading(false);
      console.error('Failed to fetch event attendance:', error);
      toast.error(p('categoryConfigurationFetchFailed'));
    }
  }, [companyID, setLoading]);
  useEffect(() => {
    if (companyID) {
      fetchEventAttendence();
    }
  }, [companyID, fetchEventAttendence]);

  const renderEventAttendence = () => {
    return eventAttendence.map((event, index) => (
      <tr
        style={{ background: index % 2 ? '#fff' : '#F9FAFB' }}
        key={`event-attendence-${event.eventId}`}
      >
        <td>
          <Link to={`/events/edit/${event.eventId}`}>{event.eventName}</Link>
        </td>
        <td>{event.declaredAmount}</td>
        <td>{event.attendedAmount}</td>
      </tr>
    ));
  };

  return (
    <Container>
      <div
        className="mt-4"
        style={{
          display: 'flex',
          paddingBottom: 5,
          marginTop: 5,
          background: '#fff',
          borderRadius: 6,
          border: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        <Table responsive striped>
          <thead>
            <tr>
              <th className="bold" style={{ color: '#4D576A' }}>
                {s('name')}
              </th>
              <th className="bold" style={{ color: '#4D576A' }}>
                {p('EventAttendenceCard.declaredAmount')}
              </th>
              <th className="bold" style={{ color: '#4D576A' }}>
                {p('EventAttendenceCard.attendedAmount')}
              </th>
            </tr>
          </thead>
          <tbody>{renderEventAttendence()}</tbody>
        </Table>
      </div>
    </Container>
  );
};

export default EventAttendenceCard;
